export const PRIORITY =
[    "Media",
   "Alta",
    "Urgente",]
;

export const PRIORITY_UNDER = [
    0,1,2
];

export const PRIORITYIN = {
    "Media" : 0,
    "Alta" : 1,
    "Urgente" : 2,
};

export const PRIORITYOUT = {
    0 : "Media",
    1 : "Alta",
    2 : "Urgente"
};

export const PRIORITYA = [
    {id:0,  descr: "Media"},
    {id:1,  descr:"Alta"},
    {id:2,  descr:"Urgente"}
];
export const PRIORITYACT =[    
    "Baja",
    "Media",
    "Alta"
];
export const PRIORITYACTIN = { //Prioridad Activo IN
    "Baja" : 0,
    "Media" : 1,
    "Alta" : 2
}
export const PRIORITYACTOUT = { //Prioridad Activo OUT
    0: "Baja",
    1: "Media",
    2: "Alta"
}